import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { EventManager } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})

export class ResizeService {

    get onResize$(): Observable<Window> {
        return this.resizeSubject.asObservable();
    }

    private resizeSubject: BehaviorSubject<Window>;

    constructor(private eventManager: EventManager) {
        this.resizeSubject = new BehaviorSubject(window);
        this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
    }

    private onResize(event: UIEvent) {
        this.resizeSubject.next(<Window>event.target);
    }
}